/**
 * this file copy from Mui source to change below Menu content
 * ! just add some type and MenuComponent for custom our Menu
 * https://github.com/mui-org/material-ui/blob/next/packages/material-ui/src/Select/SelectInput.js
 */
import { __assign, __read, __rest } from "tslib";
import React, { forwardRef, useState } from 'react';
import clsx from 'clsx';
import { isFragment } from 'react-is';
// @ts-ignore that is exist in source, but no type
import { isFilled } from '@material-ui/core/InputBase/utils';
// @ts-ignore
// import MuiError from '@material-ui/utils/macros/MuiError.macro';
import MuiMenu from '@material-ui/core/Menu';
import { ownerDocument, useControlled, useForkRef, } from '@material-ui/core/utils';
import { SelectArrowDownIcon } from '../../styles/SelectArrowDownIcon';
function areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) {
        return a === b;
    }
    return String(a) === String(b);
}
function isEmpty(display) {
    return display == null || (typeof display === 'string' && !display.trim());
}
/**
 * internal component
 */
var SelectInput = forwardRef(function (props, ref) {
    var _a, _b, _c;
    var 
    // TODO: fix menu when RcMenu fix scroll issue
    // ! change default arrow icon
    _d = props.MenuComponent, 
    // TODO: fix menu when RcMenu fix scroll issue
    // ! change default arrow icon
    MenuComponent = _d === void 0 ? MuiMenu : _d, ariaLabel = props["aria-label"], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, _e = props.classes, classes = _e === void 0 ? {} : _e, className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, 
    // ! change default arrow icon
    _f = props.IconComponent, 
    // ! change default arrow icon
    IconComponent = _f === void 0 ? SelectArrowDownIcon : _f, inputRefProp = props.inputRef, labelId = props.labelId, _g = props.MenuProps, MenuProps = _g === void 0 ? {} : _g, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, readOnly = props.readOnly, renderValue = props.renderValue, _h = props.SelectDisplayProps, SelectDisplayProps = _h === void 0 ? {} : _h, tabIndexProp = props.tabIndex, 
    // catching `type` from Input which makes no sense for SelectInput
    type = props.type, valueProp = props.value, 
    // variant = 'standard',
    other = __rest(props, ["MenuComponent", 'aria-label', "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value"]);
    var _j = __read(useControlled({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select',
    }), 2), value = _j[0], setValueState = _j[1];
    var inputRef = React.useRef(null);
    var displayRef = React.useRef(null);
    var _k = __read(React.useState(null), 2), displayNode = _k[0], setDisplayNode = _k[1];
    var isOpenControlled = React.useRef(openProp != null).current;
    var _l = __read(useState(), 2), menuMinWidthState = _l[0], setMenuMinWidthState = _l[1];
    var _m = __read(React.useState(false), 2), openState = _m[0], setOpenState = _m[1];
    var handleRef = useForkRef(ref, inputRefProp);
    var handleDisplayRef = React.useCallback(function (node) {
        displayRef.current = node;
        if (node) {
            setDisplayNode(node);
        }
    }, []);
    React.useImperativeHandle(handleRef, function () { return ({
        focus: function () {
            displayRef.current.focus();
        },
        node: inputRef.current,
        value: value,
    }); }, [value]);
    React.useEffect(function () {
        if (autoFocus) {
            displayRef.current.focus();
        }
    }, [autoFocus]);
    React.useEffect(function () {
        var label = ownerDocument(displayRef.current).getElementById(labelId);
        if (label) {
            var handler_1 = function () {
                if (getSelection().isCollapsed) {
                    displayRef.current.focus();
                }
            };
            label.addEventListener('click', handler_1);
            return function () {
                label.removeEventListener('click', handler_1);
            };
        }
        return undefined;
    }, [labelId]);
    var update = function (open, event) {
        if (open) {
            if (onOpen) {
                onOpen(event);
            }
        }
        else if (onClose) {
            onClose(event);
        }
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    var handleMouseDown = function (event) {
        // Ignore everything but left-click
        if (event.button !== 0) {
            return;
        }
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    var handleClose = function (event) {
        update(false, event);
    };
    var childrenArray = React.Children.toArray(children);
    // Support autofill.
    var handleChange = function (event) {
        var index = childrenArray
            .map(function (child) { return child.props.value; })
            .indexOf(event.target.value);
        if (index === -1) {
            return;
        }
        var child = childrenArray[index];
        setValueState(child.props.value);
        if (onChange) {
            onChange(event, child);
        }
    };
    var handleItemClick = function (child) { return function (event) {
        var newValue;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            var itemIndex = value.indexOf(child.props.value);
            if (itemIndex === -1) {
                newValue.push(child.props.value);
            }
            else {
                newValue.splice(itemIndex, 1);
            }
        }
        else {
            newValue = child.props.value;
        }
        if (child.props.onClick) {
            child.props.onClick(event);
        }
        if (value !== newValue) {
            setValueState(newValue);
            if (onChange) {
                event.persist();
                // Preact support, target is read only property on a native event.
                Object.defineProperty(event, 'target', {
                    writable: true,
                    value: { value: newValue, name: name },
                });
                onChange(event, child);
            }
        }
        if (!multiple) {
            update(false, event);
        }
    }; };
    var handleKeyDown = function (event) {
        if (!readOnly) {
            var validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on MacOS, but it's recommended by
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                'Enter',
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    var open = displayNode !== null && (isOpenControlled ? openProp : openState);
    var handleBlur = function (event) {
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            event.persist();
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: { value: value, name: name },
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    var display;
    var displaySingle;
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false;
    // No need to display any value if the field is empty.
    if (isFilled({ value: value }) || displayEmpty) {
        if (renderValue) {
            display = renderValue(value);
        }
        else {
            computeDisplay = true;
        }
    }
    var items = childrenArray.map(function (child) {
        if (!React.isValidElement(child)) {
            return null;
        }
        if (process.env.NODE_ENV !== 'production') {
            if (isFragment(child)) {
                // eslint-disable-next-line no-console
                console.error([
                    "Material-UI: The Select component doesn't accept a Fragment as a child.",
                    'Consider providing an array instead.',
                ].join('\n'));
            }
        }
        var selected;
        if (multiple) {
            if (!Array.isArray(value)) {
                // throw new MuiError(
                throw new Error('Material-UI: The `value` prop must be an array ' +
                    'when using the `Select` component with `multiple`.');
            }
            selected = value.some(function (v) { return areEqualValues(v, child.props.value); });
            if (selected && computeDisplay) {
                displayMultiple.push(child.props.children);
            }
        }
        else {
            selected = areEqualValues(value, child.props.value);
            if (selected && computeDisplay) {
                displaySingle = child.props.children;
            }
        }
        if (selected) {
            foundMatch = true;
        }
        return React.cloneElement(child, {
            'aria-selected': selected ? 'true' : undefined,
            onClick: handleItemClick(child),
            onKeyUp: function (event) {
                if (event.key === ' ') {
                    // otherwise our MenuItems dispatches a click event
                    // it's not behavior of the native <option> and causes
                    // the select to close immediately since we open on space keydown
                    event.preventDefault();
                }
                if (child.props.onKeyUp) {
                    child.props.onKeyUp(event);
                }
            },
            role: 'option',
            selected: selected,
            value: undefined,
            'data-value': child.props.value,
        });
    });
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        React.useEffect(function () {
            if (!foundMatch && !multiple && value !== '') {
                var values = childrenArray.map(function (child) { return child.props.value; });
                // eslint-disable-next-line no-console
                console.warn([
                    "Material-UI: You have provided an out-of-range value `" + value + "` for the select " + (name ? "(name=\"" + name + "\") " : '') + "component.",
                    "Consider providing a value that matches one of the available options or ''.",
                    "The available values are " + (values
                        .filter(function (x) { return x != null; })
                        .map(function (x) { return "`" + x + "`"; })
                        .join(', ') || '""') + ".",
                ].join('\n'));
            }
        }, [foundMatch, childrenArray, multiple, name, value]);
    }
    if (computeDisplay) {
        display = multiple ? displayMultiple.join(', ') : displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    var menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) {
        menuMinWidth = displayNode.clientWidth;
    }
    var tabIndex;
    if (typeof tabIndexProp !== 'undefined') {
        tabIndex = tabIndexProp;
    }
    else {
        tabIndex = disabled ? undefined : 0;
    }
    var buttonId = SelectDisplayProps.id ||
        (name ? "mui-component-select-" + name : undefined);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", __assign({ ref: handleDisplayRef, tabIndex: tabIndex, role: "button", "aria-disabled": disabled ? 'true' : undefined, "aria-expanded": open ? 'true' : undefined, "aria-haspopup": "listbox", "aria-label": ariaLabel, "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined, onKeyDown: handleKeyDown, onMouseDown: disabled || readOnly ? undefined : handleMouseDown, onBlur: handleBlur, onFocus: onFocus }, SelectDisplayProps, { className: clsx(classes.root, // TODO v5: merge root and select
            classes.select, classes.selectMenu, 
            // classes[variant],
            classes.disabled && (_a = {},
                _a[classes.disabled] = disabled,
                _a), className, SelectDisplayProps.className), 
            // The id is required for proper a11y
            id: buttonId }), isEmpty(display) ? (
        // eslint-disable-next-line react/no-danger
        React.createElement("span", { dangerouslySetInnerHTML: { __html: '&#8203;' } })) : (display)),
        React.createElement("input", __assign({ value: Array.isArray(value) ? value.join(',') : value, name: name, ref: inputRef, "aria-hidden": true, onChange: handleChange, tabIndex: -1, disabled: disabled, className: classes.nativeInput, 
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: autoFocus }, other)),
        React.createElement(IconComponent, { disabled: disabled, className: clsx(classes.icon, 
            // classes[`icon${capitalize(variant)}`],
            classes.iconOpen && (_b = {},
                _b[classes.iconOpen] = open,
                _b), classes.disabled && (_c = {},
                _c[classes.disabled] = disabled,
                _c)) }),
        React.createElement(MenuComponent, __assign({ id: "menu-" + (name || ''), anchorEl: displayNode, open: open, onClose: handleClose }, MenuProps, { MenuListProps: __assign({ 'aria-labelledby': labelId, role: 'listbox', disableListWrap: true }, MenuProps.MenuListProps), PaperProps: __assign(__assign({}, MenuProps.PaperProps), { style: __assign({ minWidth: menuMinWidth }, (MenuProps.PaperProps != null
                    ? MenuProps.PaperProps.style
                    : null)) }) }), items)));
});
SelectInput.defaultProps = {};
SelectInput.displayName = 'SelectInput';
export { SelectInput };
